"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from "react";
import { ContactSalesModal } from "./ContactSalesModal";
import { ContactSalesContext } from "./hooks/useContactSales";
import type { ContactSalesOrigin } from "./types";
export function ContactSalesProvider(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const [origin, setOrigin] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = next => {
      setOrigin(next);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const open = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOrigin(null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const close = t2;
  const t3 = !!origin;
  let t4;
  if ($[2] !== origin || $[3] !== t3) {
    t4 = {
      isOpen: t3,
      origin,
      open,
      close
    };
    $[2] = origin;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ContactSalesModal />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t4) {
    t6 = <ContactSalesContext.Provider value={t4}>{children}{t5}</ContactSalesContext.Provider>;
    $[6] = children;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}